import { render, staticRenderFns } from "./AddVendorModal.vue?vue&type=template&id=113806a1&scoped=true&"
import script from "./AddVendorModal.vue?vue&type=script&lang=js&"
export * from "./AddVendorModal.vue?vue&type=script&lang=js&"
import style0 from "./AddVendorModal.vue?vue&type=style&index=0&id=113806a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113806a1",
  null
  
)

export default component.exports